import { Button, Card, CardContent, Input, Label, Textarea } from "@repo/ui";
import { useState } from "react";

import Footer from "@/components/footer";
import Navbar from "@/components/navbar";

export default function Contact() {
  const [status, setStatus] = useState<"idle" | "sent">("idle");

  function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setStatus("sent");
  }

  return (
    <div>
      <Navbar />
      <main className="mx-auto max-w-xl px-4 sm:px-6 py-16">
        <h1 className="text-3xl font-semibold tracking-tight">Contact</h1>
        <p className="text-muted-foreground mt-2">
          Send a quick note. I’ll get back within 1–2 business days.
        </p>

        <Card className="mt-8">
          <CardContent className="pt-6">
            <form onSubmit={onSubmit} className="space-y-4">
              <div className="grid sm:grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label htmlFor="name">Name</Label>
                  <Input id="name" required placeholder="Your name" />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="email">Email</Label>
                  <Input id="email" type="email" required placeholder="you@example.com" />
                </div>
              </div>
              <div className="space-y-2">
                <Label htmlFor="message">Message</Label>
                <Textarea id="message" required placeholder="How can I help?" rows={6} />
              </div>
              <div className="flex justify-end">
                <Button type="submit">Send</Button>
              </div>
              {status === "sent" && (
                <p className="text-sm text-green-600">Thanks! Your message has been sent (demo).</p>
              )}
            </form>
          </CardContent>
        </Card>
      </main>
      <Footer />
    </div>
  );
}
